<template>
  <section id="indicators">
    <home
      id="home"
      ref="home"
      :user-state="userState"
      :user-city="userCity"
      :indicators="indicators"
      :categories="categories"
      :fieldsets="fieldsets"
      :saved-reports="savedReports"
      :user-report="userReport"
      :results="results"
      :questionnaires="questionnaires"
      :questionnaires-intelligent="questionnairesIntelligent"
      :rates="rates"
      :form-data="formData"
      :config="config"
      :roleId="roleId"
    />

    <flag
      id="flag"
      ref="flag"
      :index="categories.flag.id"
      :indicators="categories.flag.indicators"
      :results="chartResults('flag')"
    />

    <bus
      id="bus"
      ref="bus"
      :index="categories.bus.id"
      :indicators="categories.bus.indicators"
      :results="chartResults('bus')"
    />

    <briefcase
      id="briefcase"
      ref="briefcase"
      :index="categories.briefcase.id"
      :indicators="categories.briefcase.indicators"
      :results="chartResults('briefcase')"
    />

    <invoice
      id="invoice"
      ref="invoice"
      :index="categories.invoice.id"
      :indicators="categories.invoice.indicators"
      :results="chartResults('invoice')"
    />

    <departure
      id="departure"
      ref="departure"
      :index="categories.departure.id"
      :indicators="categories.departure.indicators"
      :results="chartResults('departure')"
    />

    <security
      id="security"
      ref="security"
      :index="categories.security.id"
      :indicators="categories.security.indicators"
      :results="chartResults('security')"
    />

    <set-dti
      id="SET-mini"
      ref="SET-mini"
      :index="categories['SET-mini'].id"
      :indicators="categories['SET-mini'].indicators"
      :results="chartResults('SET-mini')"
      :diagnosis="diagnosisChart"
      :config-form="config"
      :insights="resultInsights"
    />

    <chart
      id="chart"
      ref="chart"
      :index="categories.chart.id"
      :indicators="categories.chart.indicators"
      :results="chartResults('chart')"
      :analysis="resultAnalysis"
      :config-form="config"
      :report_full="report_full"
    />

    <modal v-show="saving" :form="report" @close="saving = false" />
  </section>
</template>

<script>
import Layout from '@/Pages/Indicators/Layout'
import Home from '@/Indicators/HomeIndicator'
import Flag from '@/Indicators/FlagIndicator'
import Bus from '@/Indicators/BusIndicator'
import Briefcase from '@/Indicators/BriefcaseIndicator'
import Invoice from '@/Indicators/InvoiceIndicator'
import Departure from '@/Indicators/DepartureIndicator'
import Security from '../../Indicators/SecurityIndicator.vue'
import SetDti from '@/Indicators/SETIndicator'
import Chart from '@/Indicators/ChartIndicator'
import Modal from '@/Indicators/Components/ReportModal'

export default {
  metaInfo: {
    title: 'Indicadores',
  },
  components: {
    Home,
    Flag,
    Bus,
    Briefcase,
    Invoice,
    Departure,
    Security,
    SetDti,
    Chart,
    Modal,
  },
  layout: Layout,
  props: {
    roleId: Number,
    userState: Number,
    userCity: Array,
    indicators: Object,
    categories: Object,
    fieldsets: Object,
    results: Object,
    formData: Object,
    config: Object,
    questionnaires: Array,
    questionnairesIntelligent: Array,
    rates: Array,
    savedReports: Array,
    userReport: Number,
    report_full: Array,
  },
  data() {
    return {
      $this: this,
      get diagnosisChart() {
        return this.$this.results?.diagnosis
      },
      get resultInsights() {
        return this.$this.results?.insights ?? []
      },
      get resultAnalysis() {
        return this.$this.results?.analysis ?? []
      },
      report: null,
      saving: false,
    }
  },
  mounted() {
    this.$parent.showMenus()
    this.$parent.refreshMenus()
  },
  updated() {
    this.$parent.refreshMenus()
  },
  methods: {
    chartResults(category) {
      if (!this.results?.chart || !this.results.chart[category]) {
        return []
      }

      const charts = []

      this.results.chart[category]['_order'].forEach((chart) =>
        charts.push(this.results.chart[category][chart]),
      )

      return charts
    },
    save(form) {
      if (Object.keys(this.results).length === 0) {
        return alert('Realize uma consulta antes de salvar!')
      }

      this.report = this.$inertia.form({ form: form, results: this.results, alias: null })

      this.saving = true
    },
  },
}
</script>

<style scoped>
#indicators {
  background-color: #fff;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.08);
}
</style>
